<script setup lang="ts">
const props = defineProps<{ label: string; content: any; classPre?: string }>()
</script>
<!-- FigmaStore.context.figma_file.document -->

<template>
	<div class="text-auto">
		<div class="bg-old-neutral-300 p-1">{{ label }}</div>
		<pre :class="'overflow-y-scroll text-xs ' + (classPre ? classPre : '')">
					{{ content }}
				</pre>
		<!-- </Fieldset> -->
	</div>
</template>

<style lang="css" scoped></style>
